export const addParamsToUrl = (url, params) => {
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "" && key !== "i") {
      url.searchParams.set(key, value);
    }
  });
};
